import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
} from "reactstrap";
import Header from "components/Headers/Header";
import AddTestimonial from "components/Testimonial/AddTestimonial";
import AllTestimonial from "components/Testimonial/AllTestimonial";
import Dataservices from "../../services/requestApi";
import Loader from "components/loader/Loader";

function Testimonial(){
  const [name, setName] = useState("");
  const [profession, setProfession] = useState("");
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(1);
  const [allTestimonials, setAllTestimonials] = useState([]);
  const [update, setUpdate] = useState(false);
  const [editId, setEditId] = useState("");
  const [search, setSearch] = useState("");
  const [ready, setReady] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [image, setImage] = useState(null);

  const getAllTestimonials = async () => {
    try {
      const res = await Dataservices.TestimonialAll();
      setAllTestimonials(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllTestimonials();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setThumbnail(URL.createObjectURL(file));
    } else {
      setImage(null);
      setThumbnail(null);
    }
  };

  const handleAddTestimonial = async (e) => {
    e.preventDefault();
    setReady(true);
    const form = new FormData();
    form.append("name", name);
    form.append("profession", profession);
    form.append("feedback", feedback);
    form.append("rating", rating);
    form.append("image", image);

    try {
      await Dataservices.TestimonialAdd(form);
      resetForm();
      getAllTestimonials();
    } catch (err) {
      console.log(err);
    } finally {
      setReady(false);
    }
  };

  const handleUpdateTestimonial = async (e) => {
    e.preventDefault();
    setReady(true);
    const form = new FormData();
    form.append("name", name);
    form.append("profession", profession);
    form.append("feedback", feedback);
    form.append("rating", rating);
    if (image) form.append("image", image);

    try {
      await Dataservices.TestimonialUpdate(editId, form);
      resetForm();
      getAllTestimonials();
    } catch (err) {
      console.log(err);
    } finally {
      setReady(false);
    }
  };

  const handleEdit = (item) => {
    setUpdate(true);
    setEditId(item._id);
    setName(item.name);
    setProfession(item.profession);
    setFeedback(item.feedback);
    setRating(item.rating);
    setThumbnail(item.image || null);
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    try {
      await Dataservices.TestimonialDelete(id);
      getAllTestimonials();
    } catch (err) {
      console.log(err);
    }
  };

  const resetForm = () => {
    setName("");
    setProfession("");
    setFeedback("");
    setRating(1);
    setImage(null);
    setThumbnail(null);
    setUpdate(false);
    setEditId("");
  };

  const filteredTestimonials = allTestimonials.filter(t =>
    t.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Header show={false} />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="4">
            <Card className="card-profile shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col>
                    <h3 className="mb-0">
                      {update ? "Update Testimonial" : "Add Testimonial"}
                    </h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <AddTestimonial
                  name={name}
                  setName={setName}
                  profession={profession}
                  setProfession={setProfession}
                  feedback={feedback}
                  setFeedback={setFeedback}
                  rating={rating}
                  setRating={setRating}
                  handleImage={handleImageUpload}
                  thumbnail={thumbnail}
                  statusupdate={update}
                  addTestimonial={handleAddTestimonial}
                  updateTestimonial={handleUpdateTestimonial}
                />
              </CardBody>
            </Card>
          </Col>

          <Col xl="8">
            <Card className="shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="9">
                    <h3 className="mb-0">All Testimonials</h3>
                  </Col>
                  <Col lg="3">
                    <FormGroup className="mb-0">
                      <Input
                        className="shadow"
                        id="search"
                        placeholder="Search by Name"
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Loader show={ready} />
                <AllTestimonial
                  allTestimonial={filteredTestimonials}
                  updateTestimonial={handleEdit}
                  deletetes={handleDelete}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Testimonial;
